export enum YandexListTypes {
    yaOrgs = "yaOrgs",
    yaBGs = "yaBGs",
    yaBUs = "yaBUs",
    yaCountries = "yaCountries",
}
